import { createRouter, createWebHistory } from 'vue-router'
import useAuthStore from '../stores/auth.store';
import useTableStore from '../stores/table.store';
import { Warehouse, Category, Product, ML_Publication, Shopify_Publication, COP_Publications, LIV_Publications, WAL_Publication} from '../Api/ApiLibrary' 
import app from '../main'
const warehouse = new Warehouse();
const category = new Category();
const product = new Product();
const ml_publication = new ML_Publication();
const shopify_publication = new Shopify_Publication();

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/vista1',
      name: 'vista1',
      component: () => import('../views/MiVista.vue')
    },
    {
      path: '/productos',
      name: 'productos',
      component: () => import('../views/ProductosView.vue'),
      params: true
    },
    {
      //404
      path: '/:pathMatch(.*)*',
      name: '404',
      component: () => import('../views/NotFoundView.vue')
    },
    {
      path: '/pedidos',
      name: 'pedidos',
      component: () => import('../views/PedidosView.vue')
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: () => import('../views/ClientesView.vue')
    },
    {
      path: '/mercadolibre/devoluciones',
      name: 'devoluciones_ml',
      component: ()=> import('../views/DevolucionesView.vue')
    },
    {
      path: '/mercadolibre/ventas',
      name: 'ventas_ml',
      component: ()=> import('../views/VentasView.vue')
    },
    {
      path: '/mercadolibre/preguntas',
      name: 'preguntas_ml',
      component: ()=> import('../views/PreguntasView.vue')
    },
    {
      path: '/mercadolibre/pagos',
      name: 'pagos_ml',
      component: ()=> import('../views/PagosView.vue')
    },
    {
      path: '/mercadolibre/publicaciones',
      name: 'publicaciones_ml',
      component: ()=> import('../views/MercadoLibre/ML_Publications.vue')
    },
    {
      path: '/mercadolibre/publicaciones/:id',
      name: 'ficha_publicaciones_ml',
      component: ()=> import('../views/MercadoLibre/FichaPublicacionView.vue')
    },
    {
      path: '/publicaciones',
      name: 'publicaciones',
      component: ()=> import('../views/PublicacionesView.vue'),
      params: true
      },
    {
      path: '/amazon/pagos',
      name: 'pagos_amz',
      component: ()=> import('../views/Amazon/PagosView.vue')
    },
    {
      path: '/amazon/devoluciones',
      name: 'devoluciones_amz',
      component: ()=> import('../views/Amazon/DevolucionesView.vue')
    },
    {
      path: '/amazon/preguntas',
      name: 'preguntas_amz',
      component: ()=> import('../views/Amazon/PreguntasView.vue')
    },
    {
      path: '/amazon/ventas',
      name: 'ventas_amz',
      component: ()=> import('../views/Amazon/VentasView.vue')
    },
    {
      path: '/amazon/publicaciones',
      name: 'publicaciones_amz',
      component: ()=> import('../views/Amazon/AMZPublicationsView.vue')
    },
    {
      path: '/anymarket/uploaded',
      name: 'uploaded_am',
      component: ()=> import('../views/AnyMarket/UploadedView.vue')
    },
    {
      path: '/anymarket/transmissions',
      name: 'transmissions_am',
      component: ()=> import('../views/AnyMarket/TransmissionsView.vue')
    },
    {
      path: '/anymarket/pagos',
      name: 'pagos_am',
      component: ()=> import('../views/Amazon/PagosView.vue')
    },
    {
      path: '/anymarket/devoluciones',
      name: 'devoluciones_am',
      component: ()=> import('../views/Amazon/DevolucionesView.vue')
    },
    {
      path: '/anymarket/preguntas',
      name: 'preguntas_am',
      component: ()=> import('../views/Amazon/PreguntasView.vue')
    },
    {
      path: '/anymarket/ventas',
      name: 'ventas_am',
      component: ()=> import('../views/AnyMarket/SalesView.vue')
    },
    {
      path: '/anymarket/ventas-v2',
      name: 'ventas_am_v2',
      component: ()=> import('../views/AnyMarket/AM_VentasV2View.vue')
    },
    {
      path: '/anymarket/publicaciones',
      name: 'publicaciones_am',
      component: ()=> import('../views/AnyMarket/AM_Publications.vue')
    },
    {
      path: '/anymarket/publicaciones/:id',
      name: 'ficha_publicaciones_am',
      component: ()=> import('../views/AnyMarket/FichaPublicacionView.vue')
    },
    {
      path: '/walmart/publicaciones',
      name: 'publicaciones_wal',
      component: ()=> import('../views/Walmart/WALPublicationsView.vue')
    },
    {
      path: '/walmart/publicaciones/:id',
      name: 'ficha_publicaciones_wal',
      component: ()=> import('../views/Walmart/WAL_FichaPublicacionView.vue')
    },
    {
      path: '/walmart/ventas',
      name: 'ordenes_wal',
      component: ()=> import('../views/Walmart/WALOrdersView.vue')
    },
    {
      path: '/walmart/devoluciones',
      name: 'devoluciones_wal',
      component: ()=> import('../views/Walmart/WAL_DevolucionesView.vue'),
      meta: { forcedQuery: { channel: 'Walmart' } }
    },
    {
      path: '/configuracion',
      name: 'configuracion',
      props: true,
      component: ()=> import('../views/General/ConfiguracionView.vue')
    },
    {
      path: '/configuracion/cronjobs',
      name: 'configuracion_cronjobs',
      component: () => import('../views/General/RecurringJobsView.vue')
    },
    {
      path: '/configuracion/:plataforma',
      name: 'configuracion_ml',
      props: true,
      component: ()=> import('../views/General/ConfiguracionView.vue')
    },
    {
      path: '/notificaciones',
      name: 'notificaciones',
      component: ()=> import('../views/NotificacionesView.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: ()=> import('../views/LoginView.vue')
    },
    {
      path: '/tareas',
      name: 'tareas',
      component: ()=> import('../views/General/TasksView.vue')
    },
    {
      path: '/auditorias/mercadolibre',
      name: 'auditorias-ml',
      component: () => import('../views/General/AuditMLView.vue')
    },
    {
      path: '/auditorias/mercadolibre/:id',
      name: 'auditorias-ml-detail',
      component: () => import('../views/General/AuditMLDetailPage.vue')
    },
    {
      path: '/auditorias/shopify',
      name: 'auditorias-shopify',
      component: () => import('../views/General/AuditShopifyView.vue')
    },
    {
      path: '/auditorias/shopify/:id',
      name: 'auditorias-shopify-detail',
      component: () => import('../views/General/AuditShopifyDetailPage.vue')
    },
    {
      path: '/auditorias/anymarket',
      name: 'auditorias-anymarket',
      component: () => import('../views/General/AuditAnyMarketView.vue')
    },
    {
      path: '/auditorias/anymarket/:id',
      name: 'auditorias-anymarket-detail',
      component: () => import('../views/General/AuditAnyMarketDetailPage.vue')
    },
    {
      path: '/auditorias/coppel',
      name: 'auditorias-coppel',
      component: () => import('../views/General/AuditCoppelView.vue')
    },
    {
      path: '/auditorias/coppel/:id',
      name: 'auditorias-coppel-detail',
      component: () => import('../views/General/AuditCoppelDetailPage.vue')
    },
    {
      path: '/auditorias/liverpool',
      name: 'auditorias-liverpool',
      component: () => import('../views/General/AuditLiverpoolView.vue')
    },
    {
      path: '/auditorias/liverpool/:id',
      name: 'auditorias-liverpool-detail',
      component: () => import('../views/General/AuditLiverpoolDetailPage.vue')
    },
    {
      path: '/auditorias/walmart',
      name: 'auditorias-walmart',
      component: () => import('../views/General/AuditWalmartView.vue')
    },
    {
      path: '/auditorias/walmart/:id',
      name: 'auditorias-walmart-detail',
      component: () => import('../views/General/AuditWalmartDetailPage.vue')
    },
    {
      path: '/usuarios',
      name : 'usuarios',
      component: ()=> import('../views/UsuariosView.vue')
    },
    {
      path: '/productos/crear',
      name: 'nuevo_producto',
      component: ()=> import('../views/General/NuevoProductoView.vue')
    },
    {
      path: '/productos/editar/:id',
      name: 'editar_producto',
      props: true,
      component: ()=> import('../views/General/NuevoProductoView.vue')
    },
    {
      path: '/productos/ver/:id',
      name: 'ver_producto',
      props: true,
      component: ()=> import('../views/General/FichaProducto.vue')
    },
    {
      path: '/kits',
      name: 'kits',
      component: () => import('../views/Kits/KitsView.vue'),
      params: true
    },
    {
      path: '/erp-notification-logs',
      name: 'erp-notification-logs',
      component: () => import('../views/ErpNotificationLogs/ErpNotificationLogsView.vue')
    },
    {
      path: '/kits/crear',
      name: 'nuevo_kit',
      component: () => import('../views/Kits/FormularioKit.vue')
    },
    {
      path: '/kits/editar/:id',
      name: 'editar_kit',
      props: true,
      component: () => import('../views/Kits/FormularioKit.vue')
    },
    {
      path: '/kits/ver/:id',
      name: 'ver_kit',
      props: true,
      component: () => import('../views/Kits/FichaKit.vue')
    },
    {
      path: '/tienda/publicaciones',
      name: 'publicaciones_tienda',
      component: ()=> import('../views/Prestashop/PS_Publications.vue')
    },
    {
      path: '/tienda/ventas',
      name: 'ventas_tienda',
      component: ()=> import('../views/Prestashop/PS_OrdersView.vue')
    },
    {
      path: '/images/upload',
      name: 'upload_images',
      component: ()=> import('../views/ImageUploaderView.vue')
    },
    {
      path: '/shopify/publicaciones',
      name: 'publicaciones_shopify',
      component: ()=> import('../views/Shopify/Shopify_Publications.vue')
    },
    {
      path: '/shopify/publicaciones/:id',
      name: 'ficha_publicaciones_shopify',
      component: ()=> import('../views/Shopify/FichaPublicacionView.vue')
    },
    {
      path: '/shopify/ventas',
      name: 'ventas_shopify',
      component: ()=> import('../views/Shopify/Shopify_VentasView.vue')
    },
    {
      path: '/coppel/publicaciones',
      name: 'publicaciones_coppel',
      component: () => import('../views/Coppel/COP_PublicationsView.vue')
    },
    {
      path: '/coppel/publicaciones/:id',
      name: 'ficha_publicaciones_coppel',
      component: () => import('../views/Coppel/COP_FichaPublicacionView.vue')
    },
    {
      path: '/coppel/ventas',
      name: 'ventas_coppel',
      component: () => import('../views/Coppel/COP_VentasView.vue')
    },
    {
      path: '/coppel/devoluciones',
      name: 'devoluciones_cop',
      component: () => import('../views/Coppel/COP_DevolucionesView.vue'),
      // Sin `channel`, api/returns usa MercadoLibre; aplica también al listado y al Excel.
      meta: { forcedQuery: { channel: 'Coppel' } }
    },
    {
      path: '/liverpool/ventas',
      name: 'ventas_liverpool',
      component: () => import('../views/Liverpool/LIV_VentasView.vue')
    },
    {
      path: '/liverpool/devoluciones',
      name: 'devoluciones_lp',
      component: () => import('../views/Liverpool/LIV_DevolucionesView.vue'),
      // Sin `channel`, api/returns usa MercadoLibre; aplica también al listado y al Excel.
      meta: { forcedQuery: { channel: 'Liverpool' } }
    },
    {
      path: '/liverpool/publicaciones',
      name: 'publicaciones_liverpool',
      component: () => import('../views/Liverpool/LIV_PublicationsView.vue')
    },
    {
      path: '/liverpool/publicaciones/:id',
      name: 'ficha_publicaciones_liverpool',
      component: () => import('../views/Liverpool/LIV_FichaPublicacionView.vue')
    }
  ]
})

router.beforeResolve(async (to, from) => {
  if (to.path.toLowerCase() == '/productos/crear'){
    let promises = [warehouse.list(), category.list()]
    await Promise.all(promises).then(res => {
      app.provide('warehouses', res[0].data)
      app.provide('categories', res[1].data)
    })
  }

  else if(to.path.toLowerCase().match(/\/productos\/editar\/\w+/)){
    let promises = [warehouse.list(), category.list()]
    let product = new Product()
    promises.push(product.get(to.params.id))
    await Promise.all(promises).then(res => {
      app.provide('warehouses', res[0].data)
      app.provide('categories', res[1].data)
      app.provide('product', product)
    })
  }

  else if(to.path.toLowerCase().match(/\/productos\/ver\/\w+/)){
    if (from.path != to.path){
      let product = new Product()
      await product.get(to.params.id).then(res => {
        app.provide('product', product)
      })
    }
  }
  
  else if(to.path.toLowerCase().match(/\/mercadolibre\/publicaciones\/\w+/)){
    let publicacion = new ML_Publication()
    await publicacion.get(to.params.id).then(res => {
      app.provide('publicacion', publicacion)
    })
  }
  
  else if(to.path.toLowerCase().match(/\/shopify\/publicaciones\/\w+/)){
    let publicacion = new Shopify_Publication()
    await publicacion.get(to.params.id).then(res => {
      app.provide('publicacion', res.data)
    })
  }

  else if(to.path.toLowerCase().match(/\/coppel\/publicaciones\/\w+/)){
    app.provide('publicacion', null)
    try {
      const publicacion = new COP_Publications()
      const res = await publicacion.get(to.params.id)
      app.provide('publicacion', res.data)
    } catch {
      app.provide('publicacion', null)
    }
  }

  else if(to.path.toLowerCase().match(/\/liverpool\/publicaciones\/\w+/)){
    app.provide('publicacion', null)
    try {
      const publicacion = new LIV_Publications()
      const res = await publicacion.get(to.params.id)
      app.provide('publicacion', res.data)
    } catch {
      app.provide('publicacion', null)
    }
  }

  else if(to.path.toLowerCase().match(/\/walmart\/publicaciones\/\w+/)){
    app.provide('publicacion', null)
    try {
      const publicacion = new WAL_Publication()
      const res = await publicacion.get(to.params.id)
      app.provide('publicacion', res.data)
    } catch {
      app.provide('publicacion', null)
    }
  }
})

router.beforeEach(async (to,from) => {
  
  const tableStore = useTableStore();
  const authStore = useAuthStore();
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  let rutaBase = to.path.match(/\/[^/]+/)
  if (rutaBase == null) rutaBase = '/'
  if (authRequired && !authStore.usuario) {
      authStore.returnUrl = to.fullPath;
      return '/login';
  }
  // Se evalúa en cada navegación (también al limpiar filtros en la misma ruta), no solo al entrar.
  const forcedQuery = to.meta?.forcedQuery;
  if (forcedQuery && Object.entries(forcedQuery).some(([k, v]) => to.query[k] !== v)) {
    return { path: to.path, query: { ...to.query, ...forcedQuery }, hash: to.hash };
  }
  if (from.path != to.path){
    tableStore.setNumeroItems(0);
  }
});

export default router
